import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { SettingsTemplatesHub } from "../components/settings-templates/SettingsTemplatesHub.tsx"

export default function SettingsTemplatesPage() {
  useEffect(() => {
    generateDocumentTitle("Settings Templates")
  }, [])

  return <SettingsTemplatesHub />
}
